<template lang="pug">
v-card
  v-card-title Добавить ментора
  v-card-text
    //- v-tabs(v-model="tab")
    //-   v-tab сделать ментором
    //-   v-tab создать нового пользователя
    //- v-tabs-items(v-model="tab")
      //- v-tab-item
    server-data(
      :method="method"
      v-slot="{ serverData, search, init, loading, pagination }"
    )
      v-text-field(
        label="Поиск"
        filled
        rounded
        @input="search"
      )
      v-scroll-y-transition(leave-absolute)
        v-skeleton-loader(
          v-if="loading"
          type="list-item@6"
        )
      v-list.pt-0.fill-height.overflow-auto(
        v-if="!loading && serverData"
        nav
      )
        v-list-item(v-if="!serverData.length")
          v-list-item-content
            v-list-item-subtitle Доступные для выбора сотрудники не найдены...
        v-list-item(
          v-for="{ user, role_name, role } in serverData"
          :value="user"
          :key="user.id"
          :disabled="role === 8"
          @click="selectUser(user.id)"
        )
          template(v-slot:default="{ active }")
            v-list-item-content
              v-list-item-title {{ user.full_name }}
              v-list-item-subtitle {{ role_name }}
      v-pagination(
        v-if="pagination && pagination.pages   > 1"
        v-model="pagination.page"
        :length="pagination.pages"
        @input="init"
      )
</template>
<script>
export default {
  data() {
    return {
      tab: 0,
    };
  },
  methods: {
    method() {
      return this.$api.users.getOrganizationUsers(this.$user.organization.id, { expand: 'user,role_name' });
    },
    selectUser(id) {
      this.$modals.show('confirm-controller', {
        title: 'Действительно ли вы хотите изменить роль пользователя на "наставник"?',
        message: 'После изменения роли обратное изменение будет невозможно',
        dialogProps: {
          width: 800,
        },
        method: async () => {
          this.$api.mentoring.setMentorRole(this.$user.organization.id, id);
          this.$emit('success');
          this.$modals.closeAll();
        },
      });
    },
  },
};
</script>
